import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {gqlPaginatorInfo, PaginatiorInfo} from '../../../graphql/common.datatypes';
import {GroupMember} from '../../../graphql/groups.datatypes';
import {gqlGroupMember} from './getGroupMembers.api';

interface GroupMembersData {
    groupMembersInMyGroup: void
    groupMembers: void,
    myGroupMembers: void,
    myTravellers: {
        data: GroupMember[],
        paginatorInfo: PaginatiorInfo,
    }
}

export const GET_GROUP_MEMBERS_QUERY = gql`
  query myTravellers($count: Int!, $page: Int!, $where: WhereConditions, $hasRoomMember: QueryMyTravellersHasRoomMemberWhereHasConditions, $orderBy: [OrderByClause!]){
    myTravellers(first: $count, page: $page, where: $where, hasRoomMember: $hasRoomMember, orderBy: $orderBy){
      data {
        ${gqlGroupMember}
      }
      ${gqlPaginatorInfo}
    }
  }
`;

export const getMyTravellers = (count: number, page: number, where?: any, orderBy?: any, hasRoomMember?: any) => useQuery<GroupMembersData>(
    GET_GROUP_MEMBERS_QUERY,
    {
        variables: {
            count,
            page,
            where,
            orderBy,
            hasRoomMember,
        },
    }
);

export default getMyTravellers;
